export default {
  scene: {
    background: 0xffbc8d,
    shadow: 0xa05d96,
    fog: {
      color: 0xffbc8d,
      near: 50,
      far: 200
    }
  },
  camera: {
    x: -20,
    y: 5,
    z: 20
  },
  player: {
    x: 4.5,
    y: -6,
    z: 0
  },
  character: {
    x: -4.5,
    y: -6,
    z: 0
  }
}
